var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("ProgressCircular")
    : _c(
        "form",
        {
          ref: "updatePlaceForm",
          attrs: { novalidate: "", disabled: _vm.disabled },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return (() => {}).apply(null, arguments)
            },
          },
        },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "8" } },
                [
                  _c(
                    "v-card",
                    {
                      attrs: {
                        "max-width": "1200",
                        flat: "",
                        color: "transparent",
                      },
                    },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "mb-10" },
                        [
                          _c("FormHeader", {
                            attrs: {
                              loading: _vm.loading,
                              disabled: _vm.disabled,
                              link: "page-cities",
                              title: _vm.data.title
                                ? `${_vm.data.title} город`
                                : `Создать город`,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-tabs",
                        {
                          model: {
                            value: _vm.activeTab,
                            callback: function ($$v) {
                              _vm.activeTab = $$v
                            },
                            expression: "activeTab",
                          },
                        },
                        _vm._l(_vm.$options.tabs, function (tab) {
                          return _c("v-tab", { key: tab.value }, [
                            _vm._v(" " + _vm._s(tab.title) + " "),
                          ])
                        }),
                        1
                      ),
                      _c(
                        "v-tabs-items",
                        {
                          model: {
                            value: _vm.activeTab,
                            callback: function ($$v) {
                              _vm.activeTab = $$v
                            },
                            expression: "activeTab",
                          },
                        },
                        [
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "PageContent",
                                    [
                                      _c(
                                        "v-container",
                                        [
                                          _c("InputTitleSlug", {
                                            attrs: {
                                              "is-loading":
                                                _vm.loading || _vm.disabled,
                                              title: _vm.fields.title,
                                              "title-error":
                                                _vm.validationErrors.title,
                                              slug: _vm.fields.slug,
                                              isSlugEnabled: !_vm.isNew,
                                              "slug-error":
                                                _vm.validationErrors.slug,
                                            },
                                            on: {
                                              "change:title": function (
                                                $event
                                              ) {
                                                _vm.fields.title = $event
                                              },
                                              "change:slug": function ($event) {
                                                _vm.fields.slug = $event
                                              },
                                              "input:slug":
                                                _vm.$v.fields.slug.$touch,
                                            },
                                          }),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("span", [
                                                    _vm._v("Таймзона*"),
                                                  ]),
                                                  _c("v-autocomplete", {
                                                    attrs: {
                                                      "no-data-text":
                                                        "Список пуст",
                                                      id: "timezone",
                                                      outlined: "",
                                                      clearable: "",
                                                      loading: _vm.loading,
                                                      disabled: _vm.disabled,
                                                      items:
                                                        _vm.$options
                                                          .timezoneList,
                                                      "error-messages":
                                                        _vm.validationErrors
                                                          .timezone,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.fields.timezone,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.fields,
                                                          "timezone",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "fields.timezone",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "span",
                                                    [
                                                      _vm._v("Подзаголовок ("),
                                                      _c("TranslationIcon"),
                                                      _vm._v(")"),
                                                    ],
                                                    1
                                                  ),
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      outlined: "",
                                                      disabled: _vm.disabled,
                                                      loading: _vm.loading,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.fields.subtitle,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.fields,
                                                          "subtitle",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "fields.subtitle",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "span",
                                                    [
                                                      _vm._v(
                                                        "Краткое описание ("
                                                      ),
                                                      _c("TranslationIcon"),
                                                      _vm._v(")"),
                                                    ],
                                                    1
                                                  ),
                                                  _c("v-textarea", {
                                                    attrs: {
                                                      outlined: "",
                                                      disabled: _vm.disabled,
                                                      loading: _vm.loading,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.fields
                                                          .shortDescription,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.fields,
                                                          "shortDescription",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "fields.shortDescription",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("MediaFilePicker", {
                                                    attrs: {
                                                      label: "Герб",
                                                      multiple: false,
                                                      "file-type":
                                                        _vm.$options
                                                          .mediaTypesByKeys
                                                          .IMAGE,
                                                      value:
                                                        _vm.fields.emblemId,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        _vm.fields.emblemId =
                                                          $event
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("span", [
                                                    _vm._v("Площадь *"),
                                                  ]),
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      outlined: "",
                                                      id: "area",
                                                      disabled: _vm.disabled,
                                                      loading: _vm.loading,
                                                      "error-messages":
                                                        _vm.validationErrors
                                                          .area,
                                                    },
                                                    model: {
                                                      value: _vm.fields.area,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.fields,
                                                          "area",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "fields.area",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("span", [
                                                    _vm._v("Население *"),
                                                  ]),
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      outlined: "",
                                                      id: "population",
                                                      disabled: _vm.disabled,
                                                      loading: _vm.loading,
                                                      "error-messages":
                                                        _vm.validationErrors
                                                          .population,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.fields.population,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.fields,
                                                          "population",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "fields.population",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("span", [
                                                    _vm._v("Дата основания"),
                                                  ]),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        border:
                                                          "1px solid #9e9e9e",
                                                        "border-radius": "4px",
                                                      },
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        staticClass:
                                                          "native-date-input",
                                                        staticStyle: {
                                                          "margin-right":
                                                            "10px",
                                                          "margin-left": "10px",
                                                        },
                                                        attrs: {
                                                          type: "date",
                                                          disabled:
                                                            _vm.disabled,
                                                          loading: _vm.loading,
                                                        },
                                                        on: {
                                                          click: ($event) =>
                                                            $event.preventDefault(),
                                                          blur: _vm.handleFoundedAtValue,
                                                        },
                                                        model: {
                                                          value: _vm.foundedAt,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.foundedAt = $$v
                                                          },
                                                          expression:
                                                            "foundedAt",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("MediaFilePicker", {
                                                    attrs: {
                                                      label: "Обложка",
                                                      multiple: false,
                                                      "file-type":
                                                        _vm.$options
                                                          .mediaTypesByKeys
                                                          .IMAGE,
                                                      value:
                                                        _vm.fields.coverImageId,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        _vm.fields.coverImageId =
                                                          $event
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("MediaFilePicker", {
                                                    attrs: {
                                                      label: "Миниатюра",
                                                      multiple: false,
                                                      "file-type":
                                                        _vm.$options
                                                          .mediaTypesByKeys
                                                          .IMAGE,
                                                      value:
                                                        _vm.fields.thumbnailId,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        _vm.fields.thumbnailId =
                                                          $event
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("span", [
                                                    _vm._v("Адресс"),
                                                  ]),
                                                  !!_vm.fields.address
                                                    ? _c(
                                                        "LocationAutocomplete",
                                                        {
                                                          attrs: {
                                                            address:
                                                              _vm.fields
                                                                .address,
                                                            loading:
                                                              _vm.loading ||
                                                              _vm.disabled,
                                                          },
                                                          on: {
                                                            "set-location":
                                                              function (
                                                                $event
                                                              ) {
                                                                _vm.fields.address =
                                                                  $event
                                                              },
                                                            "update-location-part":
                                                              _vm.updateLocation,
                                                          },
                                                        }
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                [
                                                  _c("SeoSettings", {
                                                    attrs: {
                                                      data: _vm.data,
                                                      loading:
                                                        _vm.loading ||
                                                        _vm.disabled,
                                                    },
                                                    on: {
                                                      "on-input-seo": function (
                                                        $event
                                                      ) {
                                                        _vm.fields =
                                                          Object.assign(
                                                            {},
                                                            _vm.fields,
                                                            $event
                                                          )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "PageContent",
                                    [
                                      _c("DynamicListWrapper", {
                                        attrs: {
                                          list: _vm.fields.widgets,
                                          "error-messages":
                                            _vm.mixValidationErrors,
                                          "available-items":
                                            _vm.$options.availableWidgets,
                                          "copy-clipboard":
                                            _vm.mixCopyListItemClipboard,
                                          options: _vm.$options.options,
                                        },
                                        on: {
                                          "list-sort": _vm.mixListItemsReassort,
                                          add: _vm.mixCreateListItemHandler,
                                          option: _vm.mixListItemOptionHandler,
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "item",
                                            fn: function ({ data }) {
                                              return [
                                                _c(data.item.type, {
                                                  tag: "component",
                                                  attrs: {
                                                    "list-item": data.item,
                                                    "error-messages":
                                                      _vm
                                                        .mixDynamicListValidationErrors[
                                                        data.itemIndex
                                                      ],
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.mixListItemChangeHandler(
                                                        $event,
                                                        data.itemIndex
                                                      )
                                                    },
                                                    "change-item": function (
                                                      $event
                                                    ) {
                                                      return _vm.mixListItemChangeItemHandler(
                                                        $event,
                                                        data.itemIndex
                                                      )
                                                    },
                                                    "remove-item": function (
                                                      $event
                                                    ) {
                                                      return _vm.mixListItemRemoveItemHandler(
                                                        $event,
                                                        data.itemIndex
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _c("ManageSidePanel", {
                    ref: "manageSidePanel",
                    attrs: {
                      "is-new": !_vm.data.id,
                      isShowSortOrder: "",
                      "created-at": _vm.data.createdAt,
                      "updated-at": _vm.data.updatedAt,
                      "published-at": _vm.data.publishedAt,
                      author: _vm.data.author,
                      "is-loading": _vm.loading,
                      "is-submit-disabled": _vm.disabled,
                      "entity-id": _vm.data.id,
                      "entity-type": "city",
                      language: _vm.language,
                      translations: _vm.fields.translations,
                      sortOrder: _vm.fields.sortOrder,
                    },
                    on: {
                      delete: function ($event) {
                        return _vm.$emit("delete-city")
                      },
                      cancel: function ($event) {
                        return _vm.$router.push({ name: "page-cities" })
                      },
                      submit: _vm.submit,
                      "update-translations": function ($event) {
                        return Object.assign(_vm.fields.translations, $event)
                      },
                      "language-update": function ($event) {
                        return _vm.$emit("language-update", $event)
                      },
                      "update-sort-order": function ($event) {
                        _vm.fields.sortOrder = Number($event)
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "info-append",
                        fn: function () {
                          return [
                            _c("StatusPicker", {
                              attrs: {
                                align: "center",
                                cols: "12",
                                title: "Статус:",
                                disabled: _vm.disabled,
                                loading: _vm.loading,
                                status: _vm.fields.status,
                              },
                              on: {
                                "status:change": function ($event) {
                                  _vm.fields.status = $event
                                },
                              },
                            }),
                            !_vm.isNew
                              ? _c(
                                  "v-row",
                                  { attrs: { align: "center" } },
                                  [
                                    _c("v-col", { attrs: { cols: "6" } }, [
                                      _c("span", [
                                        _vm._v("Посмотреть на сайте"),
                                      ]),
                                    ]),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              icon: "",
                                              link: "",
                                              color: "primary",
                                              target: "_blank",
                                              href: _vm.redirerectToWebPortal,
                                              loading: _vm.loading,
                                              disabled: _vm.disabled,
                                            },
                                          },
                                          [_c("v-icon", [_vm._v("mdi-web")])],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "body",
                        fn: function () {
                          return [
                            _c(
                              "v-card",
                              { attrs: { flat: "" } },
                              [
                                _c(
                                  "v-card-subtitle",
                                  { staticClass: "grey--text" },
                                  [_vm._v(" Связи ")]
                                ),
                                _c(
                                  "v-card-text",
                                  [
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(
                                          "v-col",
                                          [
                                            _c("span", [
                                              _vm._v("Исторические личности"),
                                            ]),
                                            _c("v-select", {
                                              attrs: {
                                                outlined: "",
                                                "no-data-text": "Список пуст",
                                                "return-object": "",
                                                "item-text": "name",
                                                multiple: "",
                                                clearable: "",
                                                loading: _vm.loading,
                                                disabled: _vm.disabled,
                                                value:
                                                  _vm.fields.historicalFigures,
                                                items: _vm.historicalFigures,
                                              },
                                              model: {
                                                value:
                                                  _vm.fields.historicalFigures,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.fields,
                                                    "historicalFigures",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "fields.historicalFigures",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }